import { Injectable, computed } from '@angular/core';
import { patchState, signalState } from '@ngrx/signals';

interface AppShellState {
  leftBarWidth: number;
  leftBarCollapsed: boolean;
  leftBarFloating: boolean;
  leftBarPinning: boolean;
  isHoveringOverSidebar: boolean;
  isHoveringOverHistoryControls: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppShellService {
  private state = signalState<AppShellState>({
    leftBarWidth: 300,
    leftBarCollapsed: false,
    leftBarFloating: false,
    leftBarPinning: false,
    isHoveringOverSidebar: false,
    isHoveringOverHistoryControls: false,
  });

  public readonly leftBarWidth = computed(() => this.state.leftBarWidth());
  public readonly leftBarCollapsed = computed(() => this.state.leftBarCollapsed());
  public readonly leftBarFloating = computed(() => this.state.leftBarFloating());
  public readonly leftBarPinning = computed(() => this.state.leftBarPinning());
  public readonly isHoveringOverSidebarOrHistory = computed(() => {
    const isHoveringOverSidebar = this.state.isHoveringOverSidebar();
    const isHoveringOverHistoryControls = this.state.isHoveringOverHistoryControls();

    return isHoveringOverSidebar || isHoveringOverHistoryControls;
  });

  public setIsHoveringOverSidebar(isHovering: boolean) {
    patchState(this.state, { isHoveringOverSidebar: isHovering });
  }

  public setIsHoveringOverHistoryControls(isHovering: boolean) {
    patchState(this.state, { isHoveringOverHistoryControls: isHovering });
  }

  public setLeftBarWidth(width: number) {
    patchState(this.state, { leftBarWidth: width });
  }

  public setLeftBarCollapsed(collapsed: boolean) {
    patchState(this.state, { leftBarCollapsed: collapsed });
  }

  public setLeftBarFloating(floating: boolean) {
    patchState(this.state, { leftBarFloating: floating });
  }

  public setLeftBarPinning(pinning: boolean) {
    patchState(this.state, { leftBarPinning: pinning });
  }
}
